// Extracted from user prompt
export const DESIGN_W = 800;
export const DESIGN_H = 600;

export const BREAKPOINTS = {
  default: 0,
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
};
